export const environment = {
  production: true,
  designSystem: true,
  pathApi: 'https://api.nutrata.dev.sogivendas.com.br/api',
  ceppemAiApi: 'https://api.ai.dev.ceppem.com/ceppem/api',
  gaMeasurementId: '',
};
